import { Dialog } from "@win-reality/react-ui";
import { useState } from "react";

import { DEFAULT_TEAM_COLOR, TEAM_COLORS } from "@/lib/constants";

type TeamColorPickerModalProps = {
  teamName: string;
  currentColor?: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onColorSelect: (color: string) => void;
};

export function TeamColorPickerModal({
  teamName,
  currentColor = DEFAULT_TEAM_COLOR,
  isOpen,
  onOpenChange,
  onColorSelect,
}: TeamColorPickerModalProps) {
  const [selectedColor, setSelectedColor] = useState(currentColor);

  const handleDone = () => {
    onColorSelect(selectedColor);
    onOpenChange(false);
  };

  const handleCancel = () => {
    setSelectedColor(currentColor);
    onOpenChange(false);
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={handleCancel}
      size="lg"
      title={`${teamName} Color`}
      primaryAction={{
        label: "Done",
        onClick: handleDone,
      }}
    >
      <div className="flex gap-4 justify-center flex-wrap py-6">
        {TEAM_COLORS.map((color) => (
          <button
            key={color}
            onClick={() => setSelectedColor(color)}
            type="button"
            aria-label={`Select color ${color}`}
            className={`rounded-full transition-all ${
              selectedColor === color ? "ring-2 ring-black ring-offset-4" : ""
            }`}
          >
            <div
              className="w-8 h-8 rounded-full cursor-pointer hover:scale-105 transition-transform"
              style={{ backgroundColor: `#${color}` }}
            />
          </button>
        ))}
      </div>
    </Dialog>
  );
}
